export default __webpack_public_path__ + "static/software-1-c9791dbf7cb5c169efb39ce189939ff7.png";